import { HELP_WIDGET } from "../../actions/actionConstants.js";

export const openHelpWidget = data => {
  return {
    type: HELP_WIDGET.OPEN,
    payload: {
      data
    }
  };
};

export const closeHelpWidget = data => {
  return {
    type: HELP_WIDGET.CLOSE
  };
};

export const toggleHelpWidget = data => {
  return {
    type: HELP_WIDGET.TOGGLE
  };
};

export const updateHelpWidget = data => {
  return {
    type: HELP_WIDGET.UPDATE,
    payload: {
      data
    }
  };
};

export const resetHelpWidget = data => {
  return {
    type: HELP_WIDGET.RESET
  };
};
